'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "assign-dashboard-permissions-dialog" */'./AssignDashboardPermissionsDialogContainer');
export default Loadable({
  loader,
  LoadingComponent: () => null
});